import { userEquipmentApi } from '../api/modules/userEquipment.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import { mapPaginated } from '../models';
import { toApiKyc, userEquipmentFromApi } from '../models/userEquipment.model';
import { downloadExcelResponse, exportFileStamp } from '../utils/exportExcel';

export async function listUserEquipment(params = {}) {
  if (!USE_API) return { items: [], total: 0, page: 1, pageSize: 20 };
  try {
    return mapPaginated(await userEquipmentApi.list(params), userEquipmentFromApi);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load equipment'));
  }
}

export async function exportUserEquipmentExcel(params = {}) {
  if (!USE_API) throw new Error('Export requires API mode');
  try {
    const response = await userEquipmentApi.exportExcel(params);
    return downloadExcelResponse(
      response,
      `equipment_fleet_${exportFileStamp()}.xlsx`,
    );
  } catch (error) {
    throw new Error(error?.message || getApiErrorMessage(error, 'Export failed'));
  }
}

export async function getUserEquipment(id) {
  if (!USE_API) return null;
  try {
    return userEquipmentFromApi(await userEquipmentApi.getById(id));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load equipment'));
  }
}

export async function updateUserEquipment(id, body) {
  if (!USE_API) throw new Error('Update equipment requires API mode');
  try {
    return userEquipmentFromApi(await userEquipmentApi.update(id, body));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update equipment'));
  }
}

export async function updateUserEquipmentKyc(id, { kycStatus, rejectionReason }) {
  if (!USE_API) throw new Error('Update KYC requires API mode');
  try {
    return userEquipmentFromApi(
      await userEquipmentApi.updateKyc(id, {
        kycStatus: toApiKyc(kycStatus),
        rejectionReason: rejectionReason || null,
      }),
    );
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update equipment KYC'));
  }
}

export async function aiVerifyUserEquipment(id) {
  if (!USE_API) throw new Error('AI verify requires API mode');
  try {
    return await userEquipmentApi.aiVerify(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'AI verification failed'));
  }
}

export async function getAiVerifyHistoryUserEquipment(id) {
  if (!USE_API) return [];
  try {
    return await userEquipmentApi.aiVerifyHistory(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load AI verify history'));
  }
}

export async function getUserEquipmentIndentHistory(id) {
  if (!USE_API) return [];
  try {
    const rows = await userEquipmentApi.indentHistory(id);
    return (Array.isArray(rows) ? rows : []).map((row) => ({
      kind: row.kind || '',
      indentId: row.indentId || '',
      indentDbId: row.indentDbId ?? null,
      at: row.at || null,
      status: row.status || '',
      note: row.note || '',
      rating: row.rating != null ? Number(row.rating) : null,
    }));
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Failed to load equipment work history'),
    );
  }
}
